var ChargeBookingsService = /** @class */ (function () {
    function ChargeBookingsService($q, $http, $message, $config, $mdDialog, $translationService) {
        this.$q = $q;
        this.$http = $http;
        this.$message = $message;
        this.$mdDialog = $mdDialog;
        this.apiUrl = $config.apiUrl;
        this.$translationService = $translationService;
    }
    /**
     * Get list of charge booking
     */
    ChargeBookingsService.prototype.getChargeBookings = function () {
        return this.$http.get(this.getUrl('ChargeBooking/GetMyBookings')).then(function (response) {
            return response.data;
        }, this.$message.error);
    };
    /**
     * Get a charge booking
     * @param id
     */
    ChargeBookingsService.prototype.getChargeBooking = function (id) {
        return this.$http.get(this.getUrl('ChargeBooking/Get'), { params: { Id: id } }).then(function (response) {
            return response.data;
        }, this.$message.error);
    };
    /**
     * Delete a charge booking
     * @param chargeBookingId
     */
    ChargeBookingsService.prototype.deleteChargeBooking = function (chargeBookingId) {
        return this.$http.post(this.getUrl('ChargeBooking/Delete'), { Id: chargeBookingId }).then(function (response) {
            return response.data;
        }, this.$message.error);
    };
    /**
     * Edit|New charge booking
     * @param data
     */
    ChargeBookingsService.prototype.saveChargeBooking = function (data) {
        return this.$http.post(this.getUrl('ChargeBooking/Save'), data).then(function (response) {
            return response.data;
        }, this.$message.error);
    };
    /**
     * Get vehicles
     */
    ChargeBookingsService.prototype.getVehicles = function () {
        return this.$http.get(this.getUrl('ChargeBooking/GetVehicles')).then(function (response) {
            return response.data;
        }, this.$message.error);
    };
    /**
     * Convert Hour from 10.5 to 10:30
     * @param hour
     * @param separation
     */
    ChargeBookingsService.prototype.hourToString = function (hour, separation) {
        if (separation === void 0) { separation = ':'; }
        var duration = moment.duration(hour, 'hours'), h = duration.days() * 24 + duration.hours(), m = duration.minutes();
        if (h < 10) {
            h = '0' + h;
        }
        if (m < 10) {
            m = '0' + m;
        }
        return h + separation + m;
    };
    /**
     * Convert Hour from 10:30 to 10.5
     * @param hour
     */
    ChargeBookingsService.prototype.hourToNumber = function (hour) {
        if (!hour) {
            return 0;
        }
        var res = hour.split(':');
        return parseInt(res[0]) + (parseInt(res[1]) / 60);
    };
    /**
     * Format url
     * @param url
     */
    ChargeBookingsService.prototype.getUrl = function (url) {
        return this.apiUrl + 'mobile/' + url;
    };
    ChargeBookingsService.prototype.showConfirmDeleteChargeBooking = function ($event) {
        var self = this;
        var confirm = this.$mdDialog.confirm()
            .theme('custom-confirm')
            .clickOutsideToClose(true)
            .title(this.$translationService.getTranslation('DeleteChargeBooking')) //'Delete charge booking'
            .htmlContent(this.$translationService.getTranslation('ConfirmDeleteDeleteChargeBooking')) //"Are you sure to delete this charge booking?"
            .targetEvent($event)
            .ok(this.$translationService.getTranslation('Yes'))
            .cancel(this.$translationService.getTranslation('No'));
        // we need to revert the button so that revert the return
        return this.$mdDialog.show(confirm);
        
        // .then(function() {
        //     return self.$q.reject();
        // }, function() { 
        //     return self.$q.resolve(); 
        // });
    };
    ChargeBookingsService.prototype.CheckIfReadyToBeConnected = function (bookingId) {
        return this.$http.get(this.getUrl('ChargeBooking/CheckIfReadyToBeConnected'), { params: { Id: bookingId } }).then(function (response) {
            return 'OK';
        }, this.$message.error);
    };
    ChargeBookingsService.$inject = ['$q', '$http', '$message', '$Config', "$mdDialog", "$translationService"];
    return ChargeBookingsService;
}());
